import { bool, node, object } from "prop-types";

import cx from "classnames";

const propTypes = {
  children: node,
  indent: bool,
  lead: bool,
  style: object,
};

const RichText = (props) => {
  const { children, indent, lead, style } = props;
  return (
    <div
      style={{ ...style }}
      className={cx("rich-text", "component", {
        "rich-text--indent": indent,
        "rich-text--lead": lead,
      })}
    >
      {children}
    </div>
  );
};

RichText.propTypes = propTypes;
export default RichText;
